/* eslint-disable @typescript-eslint/no-unused-expressions */
import Web3 from 'web3';
import * as ethers from 'ethers';
import QRCodeModal from "@walletconnect/qrcode-modal";
import WalletConnect from '@walletconnect/client';
import { apiGetAccountNonce, apiGetGasPrices } from '../helpers/api';
import { convertAmountToRawNumber, convertStringToHex } from '../helpers/bignumber';
import whiteListToken from './list.json';
import { sanitizeHex } from '../helpers/utilities';
import { isMobile } from './userAgent';
import { showToast } from './utils';

type networkChangeCallback = () => void;

type accountChangeCallback = () => void;

const bridge = "https://bridge.walletconnect.org";

export class NxWeb3 {
  private static _ins: NxWeb3;
  // @ts-ignore
  WalletConnector: WalletConnect;
  static get instance(): NxWeb3 {
    return this._ins || (this._ins = new NxWeb3());
  }

  // @ts-ignore
  web3: Web3;

  isInited: boolean = false;

  accountAddress: string = '';

  balance: number = 0;

  price: number = 0;

  // Wallet Type
  // 0 not connect
  // 1 MetaMask
  // 2 Wallet Connect
  connectType: number = 0;

  get ethBalance(): number {
    return this.dether(this.balance);
  }

  get address(): string {
    return this.accountAddress;
  }

  set address(address: string) {
    this.accountAddress = address;
  }

  // contract address
  contractAddress: string = '0x64b88f10faf1603b70fb7370A00C43369F329515'
  // 0x449ed490894e5411533c6ccf718531ae99629f30 For test
  // 0xC1Ae3FE5f93C2C042FAc7bDcdF94fDD673544e31

  contractAbi: object[] = [{"inputs":[{"internalType":"string","name":"initBaseURI","type":"string"},{"internalType":"address","name":"signer","type":"address"},{"internalType":"uint256","name":"_maxBatchSize","type":"uint256"},{"internalType":"uint256","name":"_collectionSize","type":"uint256"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"approved","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"minter","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Minted","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[],"name":"PRICE","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"approve","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"baseURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getApproved","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getOwnershipData","outputs":[{"components":[{"internalType":"address","name":"addr","type":"address"},{"internalType":"uint64","name":"startTimestamp","type":"uint64"}],"internalType":"struct ERC721A.TokenOwnership","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"maxMintPerWallet","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"maxSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"mintPaused","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"nextOwnerToExplicitlySet","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ownerOf","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"string","name":"salt","type":"string"},{"internalType":"bytes","name":"token","type":"bytes"}],"name":"preMint","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"publicMint","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"newBaseURI","type":"string"}],"name":"setBaseURI","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"quantity","type":"uint256"}],"name":"setOwnersExplicit","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bool","name":"_mintPaused","type":"bool"}],"name":"setPreMintPaused","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_price","type":"uint256"}],"name":"setPrice","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"__address","type":"address"}],"name":"setSignerAddr","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenOfOwnerByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_tokenId","type":"uint256"}],"name":"tokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"transferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"withdrawAll","outputs":[],"stateMutability":"nonpayable","type":"function"}];
  constructor() {
    console.log('init');
  }

  async takeConstructor(callback: networkChangeCallback, accountaccountCallbackback: accountChangeCallback) {
    this.isInited = await this.init();
    if (this.isInited) {
      await this.connect();
      this.connectType = 1;
      this.listenNetworkChange(accountaccountCallbackback);
      this.listenAccountChange(accountaccountCallbackback);
    }
  }

  async init(): Promise<boolean> {
    try {
      // @ts-ignore
      if (!ethereum || !ethereum.isMetaMask) {
        if (!isMobile()) {
          showToast('plase install MetaMask.', 0);
        } else {
          showToast('Please copy and paste the link into the Browser section in Metamask APP.', 0);
        }
        return false;
      }

      // @ts-ignore
      if (!window.web3) {
        if (!isMobile()) {
          showToast('MetaMask not installed in your browser.', 0);
        } else {
          showToast('Please copy and paste the link into the Browser section in Metamask APP.', 0);
        }
        return false;
      }

      // @ts-ignore
      this.web3 = new Web3(window.ethereum);
      // @ts-ignore
      await window.ethereum.request({ method: 'eth_requestAccounts' });
      return true;
    } catch (error) {
      if (!isMobile()) {
        showToast('MetaMask not installed in your browser.', 0);
      } else {
        showToast('Please copy and paste the link into the Browser section in Metamask APP.', 0);
      }
      return false;
    }
  }

  async getChainId(): Promise<number> {
    const id: number = await this.web3.eth.getChainId();
    return id;
  }

  async connect() {
    try {
      // @ts-ignore
      const rst = await this.web3.eth.getAccounts();
      this.accountAddress = rst[0];

      // this.balance = parseFloat(await this.web3.eth.getBalance(this.accountAddress));
    } catch (error) {
      console.log(error);
    }
  }

  listenAccountChange(accountaccountCallbackback: accountChangeCallback) {
    if (this.isInited) {
      // @ts-ignore
      window.ethereum.on('accountsChanged', async (accounts) => {
        this.accountAddress = this.web3.utils.toChecksumAddress(accounts[0]);
        // this.balance = parseFloat(await this.web3.eth.getBalance(this.accountAddress));
        accountaccountCallbackback && accountaccountCallbackback()
      });
    }
  }

  listenNetworkChange(callback: networkChangeCallback) {
    if (this.isInited) {
      // @ts-ignore
      window.ethereum.on('chainChanged', async (_) => {
        const rst = await this.web3.eth.getAccounts();
        this.accountAddress = this.web3.utils.toChecksumAddress(rst[0]);

        // this.balance = parseFloat(await this.web3.eth.getBalance(this.accountAddress));
        callback && callback();
      });
    }
  }

  async getTotalSupply() {
    // @ts-ignore
    this.web3 = new Web3(window.ethereum);

    const factoryContract = new this.web3.eth.Contract(
      // @ts-ignore
      this.contractAbi,
      this.contractAddress,
    );
    const result = await factoryContract.methods
      .totalSupply()
      .call();

    return result;
  }

  async preMint(count: number) {
    const chainId = await this.getChainId();
    if (chainId !== 1) {
      return Error('Wrong Mainnet, change to Ethereum Mainnet.');
    }
    const tokenIttem = whiteListToken.find((item: { address: string; }) => item.address.toLocaleLowerCase() === this.accountAddress.toLocaleLowerCase());
      if (!tokenIttem) {
        return Error('Sorry, you are not whitelisted.');
      }
      const token = tokenIttem.token;
      console.log('%c🀁 token11123123123123123231323', 'color: #408059; font-size: 20px;', token);
    try {
      
      // const token = await this.getToken();


      const factoryContract = new this.web3.eth.Contract(
        // @ts-ignore
        this.contractAbi,
        this.contractAddress,
      );

      const msg = await factoryContract.methods
      .preMint(count,'PG',token).encodeABI()
      
      const _value = this.ether(this.price * count);
      const value = sanitizeHex(convertStringToHex(_value));
      await this.web3.eth.sendTransaction({
        from: this.accountAddress,
        to: this.contractAddress,
        data: msg,
        value: value
      })
      console.log('%c🀁 ', 'color: #f279ca; font-size: 20px;', msg);
      return true;
    } catch (error: any) {
      return error;
    }
  }

  async publicMint(count: number) {
    const chainId = await this.getChainId();
    if (chainId !== 1) {
      return Error('Wrong Mainnet, change to Ethereum Mainnet.');
    }

    try {
      const factoryContract = new this.web3.eth.Contract(
        // @ts-ignore
        this.contractAbi,
        this.contractAddress,
      );
      const data = await factoryContract.methods.publicMint(count).encodeABI();
      
        
      const _value = this.ether(this.price * count);
      const value = sanitizeHex(convertStringToHex(_value));
      
      await this.web3.eth.sendTransaction({
        from: this.accountAddress,
        to: this.contractAddress,
        data: data,
        value: value
      })
      return true;
    } catch (error: any) {
      return error;
    }
  }

  async rerund(token: number) {
    console.log('%c🀂 token', 'color: #7f7700; font-size: 20px;', token);
    try {
      const factoryContract = new this.web3.eth.Contract(
        // @ts-ignore
        this.contractAbi,
        this.contractAddress,
      );
      await factoryContract.methods
        .refund(token)
        .send({ from: this.accountAddress, value: this.ether(0) });
      return true;
    } catch (error) {
      return error;
    }
  }

  ether(eth: Number): number {
    return parseInt(this.web3.utils.toWei(eth.toString()), 10);
  }

  dether(eth: number): number {
    return parseFloat((eth / 1000000000000000000).toFixed(2));
  }

  async getToken() {
    const abi = new ethers.utils.AbiCoder();
    let pack = abi.encode(["string", "address", "address"], ["PG", "0x4b765ae7e9e7cf4150b6d35cc3e858c418f32489", this.accountAddress])
    const hash = ethers.utils.keccak256(pack);
    console.log(hash);
    let wallet_sign = new ethers.Wallet('0x260ea1f25531a6c62ff1f29353b91283e090a8d022dbc7d034c82113ef4f760a')
    const token = wallet_sign.signMessage(ethers.utils.arrayify(hash));
    console.log('%ctoken: ', 'color: MidnightBlue; background: Aquamarine; font-size: 18px;', token);
    return token;
  }

  async killWalletConnect() {
    let connector: WalletConnect | undefined = undefined;
    if (this.WalletConnector) {
      connector = this.WalletConnector;
    } else {
      connector = new WalletConnect({ bridge });
    }

    if (connector) {
      connector.killSession();
    }
  }

  async WalletBagConnect() {
    const connector = new WalletConnect({ bridge, qrcodeModal: QRCodeModal });
    this.WalletConnector = connector;
    this.accountAddress = connector.accounts[0];
    // check if already connected
    if (!connector.connected) {
      // create new session
      await connector.createSession()
    }
    this.connectType = 2;
  }

  async walletPreMint(count: number = 1, onSuccess: Function, onError?: Function) {
    if (!this.WalletConnector) {
      linkWalletConnect()
    }

    if (this.WalletConnector.chainId !== 1) {
      onError && onError('Wrong Mainnet, change to Ethereum Mainnet.');
      return;
    }

    const tokenIttem = whiteListToken.find((item: { address: string; }) => item.address === this.accountAddress);
    if (!tokenIttem) {
      onError && onError('Sorry, you are not whitelisted.');
      return;
    }
    const token = tokenIttem?.token;

    // @ts-ignore
    this.web3 = new Web3(window.ethereum);

    const from = this.WalletConnector.accounts[0];

    const to = this.contractAddress

    const _value = this.ether(this.price * count);
    const value = sanitizeHex(convertStringToHex(_value));

    // @ts-ignore

    const factoryContract = new this.web3.eth.Contract(
      // @ts-ignore
      this.contractAbi,
      this.contractAddress,
    );
    const data = factoryContract.methods.preMint(count, 'PG', token).encodeABI();

    const tx = {
      from,
      to,
      value,
      data,
    }

    try {
      await this.WalletConnector.sendTransaction(tx);
      onSuccess && onSuccess()
    } catch (error: any) {
      onError && onError(error)
    }
  }

  async walletPublicMint(count: number = 1, onSuccess: Function, onError?: Function) {
    if (!this.WalletConnector) {
      linkWalletConnect()
    }

    if (this.WalletConnector.chainId !== 1) {
      onError && onError('Wrong Mainnet, change to Ethereum Mainnet.');
      return;
    }

    // @ts-ignore
    this.web3 = new Web3(window.ethereum);

    const from = this.WalletConnector.accounts[0];

    const to = this.contractAddress

    const _value = this.ether(this.price * count);
    const value = sanitizeHex(convertStringToHex(_value));

    // @ts-ignore

    const factoryContract = new this.web3.eth.Contract(
      // @ts-ignore
      this.contractAbi,
      this.contractAddress,
    );
    const data = factoryContract.methods.publicMint(count).encodeABI();

    const tx = {
      from,
      to,
      value,
      data,
    }

    try {
      await this.WalletConnector.sendTransaction(tx);
      onSuccess && onSuccess()
    } catch (error: any) {
      onError && onError(error)
    }
  }

  async walletRefund(token: string, onSuccess: Function, onError?: Function) {
    if (!this.WalletConnector) {
      linkWalletConnect();
    }

    // @ts-ignore
    this.web3 = new Web3(window.ethereum);
    const from = this.WalletConnector.accounts[0];
    const to = this.contractAddress;
    const _value = this.ether(0);
    const value = sanitizeHex(convertStringToHex(_value));
    const factoryContract = new this.web3.eth.Contract(
      // @ts-ignore
      this.contractAbi,
      this.contractAddress,
    );
    const data = factoryContract.methods.refund(token).encodeABI();
    const tx = {
      from,
      to,
      value,
      data,
    }

    try {
      await this.WalletConnector.sendTransaction(tx);
      onSuccess && onSuccess();
    } catch (error) {
      onError && onError(error);
    }
  }

  async sendTransaction(count: number = 1, onSuccess?: Function, onError?: Function) {
    if (!this.WalletConnector) {
      linkWalletConnect()
    }

    const from = this.WalletConnector.accounts[0];

    const to = this.contractAddress

    const _nonce = await apiGetAccountNonce(this.WalletConnector.accounts[0], this.WalletConnector.chainId);
    const nonce = sanitizeHex(convertStringToHex(_nonce));

    const gasPrices = await apiGetGasPrices();
    const _gasPrice = gasPrices.slow.price;
    const gasPrice = sanitizeHex(convertStringToHex(convertAmountToRawNumber(_gasPrice, 9)));

    const _gasLimit = 21000;
    const gasLimit = sanitizeHex(convertStringToHex(_gasLimit));

    // const _value = 0.01;
    const _value = this.price * 1000000000000000000 * count;
    const value = sanitizeHex(convertStringToHex(_value));

    const data = '0x';

    const tx = {
      from,
      to,
      nonce,
      gasPrice,
      gasLimit,
      value,
      data,
    }
    try {
      await this.WalletConnector.sendTransaction(tx);
      onSuccess && onSuccess()
    } catch (error: any) {
      onError && onError(error)
    }
  }
}

export const linkWallet = async (accountaccountCallbackback: accountChangeCallback): Promise<boolean> => {
  await NxWeb3.instance.takeConstructor(() => { }, accountaccountCallbackback);


  if (!NxWeb3.instance.isInited) {
    return false;
  }

  return true;
}

export const isMianChain = async (): Promise<boolean> => {
  const chainId = await NxWeb3.instance.getChainId();
  if (chainId !== 4) {
    return false;
  }
  return true;
}

export const linkWalletConnect = async () => {
  await NxWeb3.instance.WalletBagConnect()
}
